import { render, staticRenderFns } from "./AddSupplier.vue?vue&type=template&id=351a9190&scoped=true&"
import script from "./AddSupplier.vue?vue&type=script&lang=js&"
export * from "./AddSupplier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351a9190",
  null
  
)

export default component.exports